/**
 * «Мій профіль» (`SPEC-005` §7.3): що людина змінює про себе сама.
 *
 * Телефон-логін, ролі й відділи в профілі не показуються, як і в легасі:
 * їх змінює супер адміністратор у картці співробітника (ВП-5).
 */
export const PROFILE_FIELDS = ['firstName', 'lastName', 'middleName', 'email', 'position'] as const

export type ProfileField = (typeof PROFILE_FIELDS)[number]

/** Що з відповіді бека переносимо в користувача сесії — лише те, що показує оболонка. */
export const SESSION_USER_FIELDS = [...PROFILE_FIELDS, 'photo', 'shortName', 'fullName'] as const

/**
 * Фото: формати й межа — ті самі, що перевіряє бек (`Ship/DTO/PhotoFileDTO`,
 * ВП-4 (а): JPG, PNG, WEBP ядра й GIF легасі, до 3 МБ). Далі бек стискає фото
 * до 700 px (ADR 032).
 */
export const PHOTO_ACCEPT: Record<string, string[]> = {
    'image/jpeg': ['.jpg', '.jpeg'],
    'image/png': ['.png'],
    'image/webp': ['.webp'],
    'image/gif': ['.gif'],
}

export const PHOTO_MAX_MB = 3

export const PROFILE_TEXTS = {
    photoHint: `Дозволено JPG, GIF, PNG або WEBP. Максимальний розмір ${PHOTO_MAX_MB} МБ.`,
    photoRejected: `Фото має бути у форматі JPG, GIF, PNG або WEBP і не більше ${PHOTO_MAX_MB} МБ.`,
    success: 'Успіх',
    infoSaved: 'Інформацію успішно оновлено.',
    passwordTitle: 'Оновлення інформації',
    passwordSaved: 'Пароль успішно оновлено.',
    unknown: 'Не вдалося зберегти зміни. Спробуйте ще раз.',
} as const

/** Фото, щойно завантажене (`POST /services/user/photo_files`). */
export interface IUploadedPhoto {
    '@id'?: string
    uuid?: string
    url?: string
}
